import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=6af9dfd6&scoped=true"
import script from "./feedBack.vue?vue&type=script&lang=js"
export * from "./feedBack.vue?vue&type=script&lang=js"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=6af9dfd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9dfd6",
  null
  
)

export default component.exports